import React, { useState, useEffect, useRef } from "react";
import { HeadersAuth } from "../funciones_utiles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { manejarError } from "../manejo_errores";
import { Button, Checkbox, Col, Form, Popover, Row, Select, Tabs } from "antd";
import { useMediaQuery } from "react-responsive";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { TablaCompleta } from "../tablas/tabla_simple";
import { DoubleRightOutlined, InfoCircleOutlined, PlusCircleOutlined, PlusOutlined, SmileOutlined, UserSwitchOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import EmojiPicker from "emoji-picker-react";
import { SelectCustom } from "../componentes/selectComponent";
import axios from "axios";
import moment from "moment";
import { FaRegTrashAlt } from "react-icons/fa";
import { NotificacionesSistema } from "../componentes/notificacionesSistema";

export const Notificaciones = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    title: "",
    body: "",
    id_tipo_destino: "",
    id_tipo_screen: "",
    categorias: "",
    pilotos: ""
  });
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [contenido, setContenido] = useState("");
  const quillTitleRef = useRef(null);
  const quillBodyRef = useRef(null);
  const [activeKey, setActiveKey] = useState("1");
  const [onLimpiarCampos, setOnLimpiarCampos] = useState(false);
  const [notificacionesPuntuales, setNotificacionesPuntuales] = useState([]);
  const [tiposDestino, setTiposDestino] = useState([]);
  const [tiposScreen, setTiposScreen] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [pilotos, setPilotos] = useState([]);
  const [esSistema, setEsSistema] = useState(false);
  const [viendoSistema, setViendoSistema] = useState(false);
  
  useEffect(() => {
    fetchNotificacionesPuntuales();
  }, [sesion.id_asociacion])

  // Obtener notificaciones puntuales
  const fetchNotificacionesPuntuales = async (sistemaValue = viendoSistema) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/notificaciones-puntuales/${sesion.id_asociacion}`,
        {
          params: {
            ...(sistemaValue ? { esSistema: "true" } : {}),
          },
          ...HeadersAuth,
        }
      );

      const { notificacionesPuntuales, tiposDestino, tiposScreen } = response.data;
      setNotificacionesPuntuales(notificacionesPuntuales);
      setTiposDestino(tiposDestino);
      setTiposScreen(tiposScreen);
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const handleReenviarNotificaciones = async (id) => {
    MySwal.fire({
      title: "¿Deseas reenviar esta notificación?",
      text: "Se enviará la notificación con el mismo contenido.",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Sí, reenviar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_DOMINIO}/notificaciones-puntuales-id/${id}`,
          HeadersAuth
        );
        // console.log("response reenvio", response.data?.notificacionesPuntuales);
        const noti = response.data?.notificacionesPuntuales;
        const tipoDestino = noti?.tipoDestino?.codigo;
        // console.log("tipoDestino y noti", tipoDestino, noti);
        if (!noti || !tipoDestino) {
          manejarAlertas("error", "No se pudo obtener la notificación");
          return;
        }

        // 🧨 Envío con datos DIRECTOS (no depende del estado)
        if (tipoDestino === "CATEGORIAS") {
          await enviarNotificacionGenerica({
            endpoint: "/notificaciones-puntuales/categoria",
            title: noti.title,
            body: noti.body,
            id_tipo_screen: noti.id_tipo_screen,
            id_tipo_destino: noti.id_tipo_destino,
            categorias: noti.notificacionDestinoDetalles.map(c => c.referenciaId)  || [],
          });
        } else if (tipoDestino === "PILOTOS") {
          await enviarNotificacionGenerica({
            endpoint: "/notificaciones-puntuales/piloto",
            title: noti.title,
            body: noti.body,
            id_tipo_screen: noti.id_tipo_screen,
            id_tipo_destino: noti.id_tipo_destino,
            pilotos: noti.notificacionDestinoDetalles.map(p => p.referenciaId) || [],
          });
        } else {
          await enviarNotificacionGenerica({
            endpoint: "/notificaciones-puntuales/todos",
            title: noti.title,
            body: noti.body,
            id_tipo_screen: noti.id_tipo_screen,
            id_tipo_destino: noti.id_tipo_destino,
          });
        }

        manejarAlertas("success", "Notificación reenviada con éxito.");
        fetchNotificacionesPuntuales();

      } catch (error) {
        manejarAlertas("error", manejarError(error));
      }
    });
  };

  // Eliminar notificaciones
  const handleEliminarNotificaciones = async (id) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_DOMINIO}/notificaciones-puntuales/eliminar/${id}`,
            HeadersAuth
          );
          fetchNotificacionesPuntuales();
          manejarAlertas("success", "Notificación eliminada con éxito.");
        } catch (error) {
          manejarAlertas("error", manejarError(error));
        }
      }
    })
  }

  // Insertar emoji en Quill
  const insertarEmojiEnQuill = (quillRef, emojiData) => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    const emoji = emojiData.emoji; // emoji-picker-react
    const selection = quill.getSelection();
    const cursorPos = selection?.index ?? quill.getLength();

    quill.insertText(cursorPos, emoji);
    quill.setSelection(cursorPos + emoji.length);
  };

  // Convertir Quill a texto plano
  const quillToPlainText = (html) => {
    if (!html) return "";
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return (temp.textContent || temp.innerText || "").trim();
  };

  const enviarNotificacionGenerica = async ({
    endpoint,
    title,
    body,
    id_tipo_screen,
    id_tipo_destino,
    categorias = [],
    pilotos = [],
  }) => {
    const notificaciones = [
      {
        title: quillToPlainText(title),
        body: quillToPlainText(body),
        id_tipo_screen,
      },
    ];

    if (!notificaciones[0].title || !notificaciones[0].body || !id_tipo_screen) {
      manejarAlertas("error", "Faltan datos en la notificación");
    }

    const payload = {
      notificaciones,
      id_tipo_destino,
      categorias,
      pilotos,
    };

    // console.log("📤 payload final:", payload);

    return axios.post(
      `${process.env.REACT_APP_DOMINIO}${endpoint}`,
      payload,
      HeadersAuth
    );
  };

  // Enviar notificación a todos los pilotos
  const enviarATodos = async () => {
    try {
      await enviarNotificacionGenerica({
        endpoint: "/notificaciones-puntuales/todos",
        title: tempDatosFormulario.title,
        body: tempDatosFormulario.body,
        id_tipo_screen: tempDatosFormulario.id_tipo_screen,
        id_tipo_destino: tempDatosFormulario.id_tipo_destino,
        categorias: tempDatosFormulario.categorias,
        pilotos: tempDatosFormulario.pilotos,
      });

      manejarAlertas("success", "Notificación enviada con éxito.");
      fetchNotificacionesPuntuales();
      limpiarCampos();
    } catch (error) {
      manejarAlertas("error", error.response?.data?.error || manejarError(error));
    }
  };

  useEffect(() => {
    if (tempDatosFormulario.id_tipo_destino === "2") {
      fetchCategorias();
    }
  }, [tempDatosFormulario.id_tipo_destino])

  // Obtener categorías de la asociación
  const fetchCategorias = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/categorias/notificables`, HeadersAuth);
      // console.log("response cate", response.data)
      setCategorias(response.data)
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  }

  // Enviar notificaciones a categorías seleccionadas
  const enviarACategorias = async () => {
    try {
      await enviarNotificacionGenerica({
        endpoint: "/notificaciones-puntuales/categoria",
        title: tempDatosFormulario.title,
        body: tempDatosFormulario.body,
        id_tipo_screen: tempDatosFormulario.id_tipo_screen,
        id_tipo_destino: tempDatosFormulario.id_tipo_destino,
        categorias: tempDatosFormulario.categorias,
        pilotos: tempDatosFormulario.pilotos,
      });

      manejarAlertas("success", "Notificación enviada con éxito.");
      fetchNotificacionesPuntuales();
      limpiarCampos();
    } catch (error) {
      manejarAlertas("error", error.response?.data?.error || manejarError(error));
    }
  };

  const handleCategoriaChange = (checkedIds) => {
    setTempDatosFormulario({
      ...tempDatosFormulario,
      categorias: checkedIds, // acá solo guardamos IDs [1,4,7]
    });
  };

  useEffect(() => {
    if (tempDatosFormulario.id_tipo_destino === "3") {
      fetchPilotosNotificables();
    }
  }, [tempDatosFormulario.id_tipo_destino]);

  // Obtener pilotos
  const fetchPilotosNotificables = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/pilotos/notificables`,
        HeadersAuth
      );
      // console.log("response pilo", response.data)
      setPilotos(response.data);
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  // Enviar notificación a pilotos seleccionados
  const enviarAPilotos = async () => {
    try {
      await enviarNotificacionGenerica({
        endpoint: "/notificaciones-puntuales/piloto",
        title: tempDatosFormulario.title,
        body: tempDatosFormulario.body,
        id_tipo_screen: tempDatosFormulario.id_tipo_screen,
        id_tipo_destino: tempDatosFormulario.id_tipo_destino,
        categorias: tempDatosFormulario.categorias,
        pilotos: tempDatosFormulario.pilotos,
      });

      manejarAlertas("success", "Notificación enviada con éxito.");
      fetchNotificacionesPuntuales();
      limpiarCampos();
    } catch (error) {
      manejarAlertas("error", error.response?.data?.error || manejarError(error));
    }
  };

  const destinoSeleccionado = tiposDestino.find(
    (t) => String(t.id) === String(tempDatosFormulario.id_tipo_destino)
  );

  const textosDestino = {
    TODOS: "Se le enviará la notificación a todos los pilotos de la asociación.",
    CATEGORIAS:
      "Se le enviará la notificación a todos los pilotos de la/s categoría/as seleccionadas.",
    PILOTO: "Se le enviará la notificación a los pilotos seleccionados.",
  };

  const textoSelect =
    destinoSeleccionado
      ? textosDestino[destinoSeleccionado.codigo] ||
        "Este destino todavía no tiene un texto definido."
      : "Seleccioná una opción para ver a quién se envía la notificación.";

  const elScroll = { x: 0 };
  const columnsPuntuales = [
    {
      title: "FECHA-HORA",
      key: "creadoEn",
      align: "left",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {`${moment(text.creadoEn).format("DD/MM/YYYY")}, ${moment(text.creadoEn).format("HH:mm")}hs`}
        </div>
      )
    },
    {
      title: "TÍTULO",
      key: "title",
      align: "left",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.title}
        </div>
      )
    },
    {
      title: "CUERPO",
      key: "body",
      align: "left",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.body}
        </div>
      )
    },
    {
      title: "DESTINO",
      key: "destino",
      align: "left",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.tipoDestino?.codigo || "-"}
        </div>
      )
    },
    {
      title: "SECCIÓN",
      key: "descripcion",
      align: "left",
      render: (text) => (
        <div style={{ fontSize: "12px", padding: "2px 4px", fontWeight: 400 }}>
          {text.tipoScreen?.descripcion || "-"}
        </div>
      )
    },
    {
      title: "OPCIONES",
      key: "opciones",
      align: "center",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 10,
          }}
        >
          {!viendoSistema && (
            <DoubleRightOutlined
              title="Reenviar"
              onClick={() => handleReenviarNotificaciones(record.id)}
              style={{ color: "blue", cursor: "pointer" }}
            />
          )}

          <FaRegTrashAlt
            title="Eliminar"
            onClick={() => handleEliminarNotificaciones(record.id)}
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
          />
        </div>
      ),
    },
  ].filter(Boolean); 

  const limpiarCampos = () => {
    setTempDatosFormulario({
      title: "",
      body: "",
      id_tipo_destino: "",
      categorias: [],
      pilotos: []
    });
  };

  const onChanges = (key) => {
    setActiveKey(key)
    limpiarCampos();
    setOnLimpiarCampos(true);
  };

  const onChange = (e) => {
    const notiSistema = e.target.checked;
    setEsSistema(notiSistema);
    fetchNotificacionesPuntuales(notiSistema);
  };

  const esTelefono = useMediaQuery({ maxWidth: 768 });

  const quillModulesSinToolbar = {
    toolbar: false, 
  };

  const quillFormatsVacios = []; 

  return (
    <>
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Gestión de notificaciones</h1>
      </section>
      {/* Formulario */}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            padding: "20px",
            margin: "0 auto",
          }}
        >
          <Tabs activeKey={activeKey} onChange={onChanges} id="tabs-notificaciones">
            <Tabs.TabPane tab="Notificaciones puntuales" key="1">
              <Form layout="vertical" 
                onFinish={
                  tempDatosFormulario.id_tipo_destino === "1"
                  ? enviarATodos
                  : tempDatosFormulario.id_tipo_destino === "2"
                  ? enviarACategorias
                  : enviarAPilotos
                }
              >
                <Row  gutter={16} align="center">
                  <Col xs={24} sm={12} style={{ width: "100%" }}>
                    <Form.Item style={{ width: "100%" }}>
                      <div style={{ width: "100%" }}>
                        <p className="nombre-campo">Título *</p>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            width: "100%",
                          }}
                        >
                          {/* Editor */}
                          <div
                            style={{
                              width: "100%",
                              border: "1px solid #d9d9d9",
                              borderRadius: 10,
                              padding: 8,
                              backgroundColor: "#fff",
                              display: "flex",
                              flexDirection: "column",
                              gap: 6,
                            }}
                          >
                            {/* Contenedor del editor y el botón */}
                            <div style={{ display: "flex", width: "100%" }}>
                              
                              {/* ReactQuill redondeado */}
                              <div style={{ flex: 1 }}>
                                <ReactQuill
                                  ref={quillTitleRef /* o quillBodyRef */}
                                  className="quill-rounded"
                                  theme="snow"
                                  value={tempDatosFormulario.title}
                                  onChange={(value) =>
                                    setTempDatosFormulario(prev => ({ ...prev, title: value }))
                                  }
                                  modules={quillModulesSinToolbar}
                                  formats={quillFormatsVacios}
                                  placeholder="Escribí el título…"
                                  style={{
                                    width: "100%",
                                  }}
                                />
                              </div>

                              {/* Botón emoji dentro del recuadro */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <Popover
                                  trigger="click"
                                  placement="bottom"
                                  content={
                                    <EmojiPicker
                                      emojiStyle="google"
                                    
                                      onEmojiClick={(emojiData) =>
                                        insertarEmojiEnQuill(quillTitleRef, emojiData)
                                      }
                                    />
                                  }
                                >
                                  <Button
                                    type="text"
                                    title="Emojis"
                                    icon={<SmileOutlined style={{ width: 20, height: 20, fontWeight: 100, color: "#BA1721" }}/>}
                                    style={{
                                      alignSelf: "center",
                                      marginLeft: 6,
                                    }}
                                  />
                                </Popover>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} style={{ width: "100%" }}>
                    <Form.Item style={{ width: "100%" }}>
                      <div style={{ width: "100%" }}>
                        <p className="nombre-campo">Cuerpo de la notificación *</p>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            width: "100%",
                          }}
                        >
                          {/* Editor */}
                          <div
                            style={{
                              width: "100%",
                              border: "1px solid #d9d9d9",
                              borderRadius: 10,
                              padding: 8,
                              backgroundColor: "#fff",
                              display: "flex",
                              flexDirection: "column",
                              gap: 6,
                            }}
                          >
                            {/* Contenedor del editor y el botón */}
                            <div style={{ display: "flex", width: "100%" }}>
                              
                              {/* ReactQuill redondeado */}
                              <div style={{ flex: 1 }}>
                                <ReactQuill
                                  ref={quillBodyRef}
                                  className="quill-rounded"
                                  theme="snow"
                                  value={tempDatosFormulario.body}
                                  onChange={(value) =>
                                    setTempDatosFormulario(prev => ({ ...prev, body: value }))
                                  }
                                  modules={quillModulesSinToolbar}
                                  formats={quillFormatsVacios}
                                  placeholder="Escribí el cuerpo de la notificación…"
                                  style={{
                                    width: "100%",
                                  }}
                                />
                              </div>

                              {/* Botón emoji dentro del recuadro */}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <Popover
                                  trigger="click"
                                  placement="bottom"
                                  content={
                                    <EmojiPicker
                                      emojiStyle="google"
                                    
                                      onEmojiClick={(emojiData) =>
                                        insertarEmojiEnQuill(quillBodyRef, emojiData)
                                      }
                                    />
                                  }
                                >
                                  <Button
                                    type="text"
                                    title="Emojis"
                                    icon={<SmileOutlined style={{ width: 20, height: 20, fontWeight: 100, color: "#BA1721" }}/>}
                                    style={{
                                      alignSelf: "center",
                                      marginLeft: 6,
                                    }}
                                  />
                                </Popover>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="rowAdmin" gutter={16} align="center">
                  <Col xs={24} sm={12} style={{ width: "100%" }}>
                    <SelectCustom
                      idCampo={"id_tipo_destino"}
                      textoOpciones={"descripcion"}
                      arrayOpciones={tiposDestino}
                      nombreCampo={"Elegí como querés enviar las notificaciones:"}
                      elPlaceholder={"Seleccioná una opción"}
                      required={true}
                      onChange={(e) =>
                        setTempDatosFormulario(prev => ({
                          ...prev,
                          id_tipo_destino: e.target.value,
                        }))
                      }
                      elValue={tempDatosFormulario.id_tipo_destino}
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ width: "100%" }}>
                    <SelectCustom
                      idCampo={"id_tipo_screen"}
                      textoOpciones={"descripcion"}
                      arrayOpciones={tiposScreen}
                      nombreCampo={"Elegí la sección de la app:"}
                      elPlaceholder={"Seleccioná una opción"}
                      required={true}
                      onChange={(e) =>
                        setTempDatosFormulario(prev => ({
                          ...prev,
                          id_tipo_screen: e.target.value,
                        }))
                      }
                      elValue={tempDatosFormulario.id_tipo_screen}
                    />
                  </Col>
                </Row>
                <Row className="rowAdmin" gutter={16} align="center">
                  <Col xs={24} sm={24} style={{ width: "100%" }}>
                    {tempDatosFormulario.id_tipo_destino === "2" && (
                      <Form.Item
                        label={
                          <span style={{ color: "#bbbbbb", marginBottom: "0.5em" }}>
                            Categorías disponibles
                          </span>
                        }
                      >
                        <Checkbox.Group
                          value={tempDatosFormulario.categorias || []}   // → array de IDs
                          onChange={handleCategoriaChange}
                          style={{ width: "100%" }}
                        >
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                            {categorias.map((categoria) => (
                              <label
                                key={categoria.id}
                                style={{
                                  border: "1px solid #d5d5d5",
                                  borderRadius: "6px",
                                  padding: "8px 12px",
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  gap: "6px",
                                }}
                              >
                                <Checkbox value={categoria.id} />
                                {categoria.categoria}
                              </label>
                            ))}
                          </div>
                        </Checkbox.Group>
                      </Form.Item>
                    )}
                  </Col>
                  <Col xs={24} sm={12} style={{ width: "100%" }}>
                    {tempDatosFormulario.id_tipo_destino === "3" && (
                      <Form.Item
                        style={{ width: "100%" }}
                      >
                        <p className="nombre-campo">Pilotos disponibles</p>

                        <Select
                          mode="multiple"
                          allowClear
                          placeholder="Seleccioná uno o varios pilotos"
                          style={{ width: "100%" }}
                          value={tempDatosFormulario.pilotos || []}
                          onChange={(values) =>
                            setTempDatosFormulario({ ...tempDatosFormulario, pilotos: values })
                          }
                          optionLabelProp="label"
                        >
                          {pilotos.map((piloto) => (
                            <Select.Option
                              key={piloto.id}
                              value={piloto.id}
                              label={piloto.nombreCompleto}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
                                <span>{piloto.nombreCompleto}</span>
                              </div>
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    )}
                  </Col>
                </Row>
                <Row className="rowAdmin" gutter={16} align="center">
                  <Col xs={24} sm={24} style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 5,
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#FFFFFF",
                        border: "1px solid #d5d5d5",
                        borderRadius: 8,
                        padding: "10px",
                        marginTop: 10
                      }}
                    >
                      <InfoCircleOutlined style={{ color: "blue" }}/>
                      <p style={{ fontSize: 14, color: "#000", fontWeight: 400, textAlign: "center" }}>
                        {textoSelect}
                      </p>
                    </div>
                  </Col>
                </Row>
                <Row gutter={16} align="middle">
                  <Col xs={24} sm={24}className="botonesResponsive"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    marginTop: 20
                  }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="boton-principal-noti"
                      style={{
                        width: "50%",
                      }}
                    >
                      Enviar
                    </Button>
                  </Col>
                </Row>
              </Form>
              {/* Tabla de notificaciones */}
              <div
                className="botonDescargar"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexWrap: "wrap",
                  alignContent: "center",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  padding:"0 16px"
                }}
              >
                {" "}
                <br></br>
                <TablaCompleta
                  tituloPDF={"notificaciones"}
                  elScroll={elScroll}
                  columns={columnsPuntuales}
                  fetchDatos={notificacionesPuntuales.length > 0 ? notificacionesPuntuales : []}
                  rowKey={"id"}
                  tituloBanner={"Notificaciones"}
                  idAsociacion={sesion.id_asociacion}
                  customMargin={"-0.1em"}
                  // mostrarBoton={false}
                  esNotificaciones={true}
                  gestionTabla={[
                    <Row>
                      {!notificacionesPuntuales?.esSistema === true && (
                        <Checkbox
                          translate="no" 
                          className="notranslate"
                          style={{
                            backgroundColor: "#233463",
                            fontSize: 16,
                            color: "#fff",
                            paddingLeft: 8,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 5,
                          }}
                          checked={viendoSistema}
                          onChange={(e) => {
                            const value = e.target.checked;
                            setViendoSistema(value);
                            fetchNotificacionesPuntuales(value);
                          }}
                        >
                          {esTelefono ? <UserSwitchOutlined title="Notificaciones del sistema enviadas" /> : "Notificaciones del sistema enviadas"}
                        </Checkbox>
                      )}
                    </Row>
                  ]}
                />
              </div>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Notificaciones del sistema" key="2">
              <NotificacionesSistema 
                id_asociacion={sesion.id_asociacion} 
                setAlerta={setAlerta}
                onLimpiarCampos={onLimpiarCampos}
                setOnLimpiarCampos={setOnLimpiarCampos} 
              />
            </Tabs.TabPane>
          </Tabs>
        </div>
      </section>
    </>
  )
}